export class SchemaRegistryConnectRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryConnectRequest.attributeTypeMap;
    }
    constructor() {
    }
}
